import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import _ from 'lodash';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ClaimService } from '../services/claims/claims.service';
import { jwtDecode } from 'jwt-decode';

@Injectable({
    providedIn: 'root'
})

export class AbilityGuard implements CanActivate {

    /* istanbul ignore next */
    constructor(
        private _router: Router,
        private _claimService: ClaimService
    ) { }

    /* istanbul ignore next */
    canActivate(next: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        return this._claimService.getClaims()
            .pipe(map(result => {
                const userToken = jwtDecode(result.token);
                const abilitiesObj = _.get(userToken, 'functionalAbilities');
                const userAbilities = _.keys(_.pickBy(abilitiesObj, _.identity));
                const requiredAbilities = next.data.abilities || [];

                if (requiredAbilities.length > 0) {
                    if (!(userToken || userAbilities) || !this.hasAccess(requiredAbilities, userAbilities)) {
                        this._router.navigateByUrl('/access-denied');
                    }
                }

                return true;
            }, catchError(() => {
                this._router.navigateByUrl(`/access-error/500`);

                return of(false);
            })));
    }

    private hasAccess(requiredAbilities: string[], userAbilities: string[]) {
        for (const requiredAbility of requiredAbilities) {
            if (_.includes(userAbilities, requiredAbility)) {
                return true;
            }
        }

        return false;
    }
}
